module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-11/12"
  }, [(_vm.loading) ? _c('pl-spinner', {
    staticStyle: {
      "margin": "100px auto"
    }
  }) : _c('div', [_c('div', {
    staticClass: "w-full bg-gray-100 text-sm text-gray-700 px-4 py-3 rounded mb-3"
  }, [_c('div', {
    staticClass: "flex items-center"
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-info text-2xl mr-4"
  }), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "mb-0.5"
  }, [_vm._v("\n            You can connect your "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("Parlay account")]), _vm._v(" to your account from a Learning Managing System at the school/district.\n          ")]), _vm._v(" "), _c('p', [_vm._v(" A course can only have "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("one connection")]), _vm._v(" for each LMS.")])])])]), _vm._v(" "), _c('div', [_c('IntegrationCard', {
    attrs: {
      "title": _vm.google_classroom_title,
      "icon": _vm.google_classroom_icon,
      "code": _vm.google_classroom_code,
      "memberships": _vm.memberships,
      "type": "connect"
    }
  })], 1)]), _vm._v(" "), (_vm.show_integration_modal) ? _c('integration-modal', {
    attrs: {
      "provider": _vm.provider_selected,
      "courses": _vm.provider_courses
    },
    on: {
      "close": _vm.closeIntegrationModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.google_classroom_modal) ? _c('google-classroom-modal', {
    attrs: {
      "courses": _vm.courses
    },
    on: {
      "close": function($event) {
        _vm.google_classroom_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_disconnect_classroom_modal) ? _c('disconnect-google-classroom-modal', {
    on: {
      "close": function($event) {
        _vm.show_disconnect_classroom_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (
    _vm.co_teachers_integration &&
    _vm.co_teachers_integration.teachers &&
    _vm.co_teachers_integration.teachers.length
  ) ? _c('integration-teacher-not-in-course-modal', {
    attrs: {
      "integration": _vm.co_teachers_integration
    },
    on: {
      "close": function($event) {
        _vm.co_teachers_integration = null
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-13959e5a!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/courses/pages/settings/integrations.vue
// module id = 2220
// module chunks = 61